import React from "react";
import "./../../style.scss";
import { withStyles, Table, Paper } from "@material-ui/core";
import styles from "./styles";
import Header from "../components/Header";
import Content from "../components/Content";
import { getTrailerContent } from "../utils";
import { SpottedTrailerMarker } from "../../../Markers";

const SpottedTrailerPopupInfo = ({ classes, trailerData }) => {
  return (
    <Paper className={`popupBGColor ${classes.mapPopupContainer} ${classes.spottedTrailerPopupContainer}`}>
      <Table className={classes.table} padding="none">
        <Header
          name={trailerData.customerName}
          address={trailerData.spottedAddress}
          id={trailerData.customerCode}
          Marker={SpottedTrailerMarker}
        />
        <Content data={getTrailerContent(trailerData)} />
      </Table>
    </Paper>
  );
};

export default withStyles(styles)(SpottedTrailerPopupInfo);
